module.exports = __webpack_public_path__ + "img/white.e15a6127.png";